import { routerRedux } from 'dva/router';
import { message } from 'antd';

export default {
  namespace: 'robot',
  state: {
    robotList: [
      {
        ProductID: 'N/A',
      },
    ],
    modalMap: new Map(),
    currentRobotIndex: 0,
    workStatusLoading: false,
    accountList: [],
  },
  reducers: {
    changeRobotList(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    changeWorkStatusLoading(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
